export enum LeftNavigationView {
    brand = 'brand',
    location = 'location',
}
